import { Apollo } from 'apollo-angular';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  createNgModule,
  Inject, Injector,
  LOCALE_ID,
  NgModuleRef,
  PLATFORM_ID,
  Type,
  ViewChild,
  ViewContainerRef,
  makeStateKey,
  TransferState
} from '@angular/core';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { CardWidgetPageResponse, ExapnsionPanels, ExpansionPanelItem, GameCategory } from 'src/app/apollo/models/base-models';
import { FRONT_PAGE_EXPANSION_PANEL } from 'src/app/apollo/front-page-games/front-page-games';
import { DomSanitizer } from '@angular/platform-browser';
import { ToggleMenuBackService } from 'src/app/services/utils/toggle-menu-back.service';
import { LoaderService } from 'src/app/services/utils/loader/loader.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { OpenDesktopDrawerService } from 'src/app/services/utils/open-desktop-drawer.service';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ClonerService } from 'src/app/services/utils/clone-object.service';
import { COUNTRY_ID, LICENCE, getDomainForLanguage, HOST_NAME } from 'src/app/global.tokens';
import { FilterGamesService } from 'src/app/services/utils/filter-games.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { activeBonusCategoryTrx, gameInfoTrx, missionsTrx, promotionsTrx, reactivationTrx, searchGameTrx, tournamentsTrx } from 'src/app/router-translation.labels';
import { FrontPageGamesService } from 'src/app/services/page/front-games.service';
import { TournamentsCarouselComponent } from './tournaments-carousel/tournaments-carousel.component';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { BasePageComponentWithDialogs } from '../base-page/base-page.component';
import { MatDialog } from '@angular/material/dialog';
import { MissionsCarouselComponent } from './missions-carousel/missions-carousel.component';
import { combineLatest, firstValueFrom, interval, timer } from 'rxjs';
import { WINDOW } from '@ng-web-apis/common';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { PaymentListService } from 'src/app/services/payment/methods/payment-list.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { PromotionCarouselComponent } from './promotion-carousel/promotion-carousel.component';
import { SearchConfigFilterItem, SearchGameService, SearchDataItem } from 'src/app/services/games/search-game.service';
import { ReactivationCarouselComponent } from './reactivation-carousel/reactivation-carousel.component';
import { loadChatScript } from 'src/app/utils/vip-chat/load-chat';
import { BonusQueueService } from 'src/app/services/wallet/bonus-queue.service';
import { DesktopService } from 'src/app/services/desktop/desktop.service';
import { ChatAccessService } from 'src/app/utils/vip-chat/chat-access.service';
import SwiperCore, { Grid, SwiperOptions } from 'swiper';
import { SeoSchemaValidator } from 'src/app/services/seo/seo-schema-validator';

import { UserInfo } from 'src/app/services/auth/login/login.models';
// import { XmasCarouselComponent } from './xmas-carousel/xmas-carousel.component';


const PROMOTIONS_KEY = makeStateKey<any[]>('PROMOTIONS_MOBILE_V1');
SwiperCore.use([Grid]);

@Component({
  selector: 'app-front-page',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.scss']
})
export class FrontPageComponent extends BasePageComponentWithDialogs implements AfterViewInit {

  // listen bonus

  categories: GameCategory[];
  operators: GameCategory[];
  searchCategories: SearchConfigFilterItem[];
  searchSwiper: SearchConfigFilterItem;
  expansionPanel: ExpansionPanelItem[];
  public swiperCategories: GameCategory[];
  public activeBonusCategory: GameCategory[] = [];
  public tournamentsAllTrx = this.translationConfig.getTranslation(tournamentsTrx);
  public missionsAllTrx = this.translationConfig.getTranslation(missionsTrx);
  public promotionsAllTrx = this.translationConfig.getTranslation(promotionsTrx);
  public reactivationAllTrx = this.translationConfig.getTranslation(reactivationTrx);
  config: SwiperOptions = {
    grid: {
      rows: 2,
    },
    slidesPerView: 3,
    centerInsufficientSlides: false,
    spaceBetween: 10,
    lazy: true,
    preloadImages: false,
  };
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private apollo: Apollo,
    private toggleBackService: ToggleMenuBackService,
    private loadingService: LoaderService,
    public detectDeviceService: DetectDeviceService,
    public openDrawerService: OpenDesktopDrawerService,
    public minimizeSiteService: MinimizeSiteService,
    private frontPageGamesService: FrontPageGamesService,
    private cloneService: ClonerService,
    private FilterGamesService: FilterGamesService,
    protected translationConfig: TranslationConfig,
    private prevUrlService: DialogClosePreviousUrl,
    private paymentListService: PaymentListService,
    private loginStatusService: LoginStatusService,
    protected licenceService: LicenceService,
    private searchGamesService: SearchGameService,
    private bonusService: BonusQueueService,
    private transferState: TransferState,
    private desktopService: DesktopService,
    private chatAccess: ChatAccessService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(HOST_NAME) private hostName: string,
    @Inject(COUNTRY_ID) public countryId: string,
    @Inject(LICENCE) public licence: string,
    @Inject(PLATFORM_ID) private platformId,
    @Inject(WINDOW) protected windowRef: Window,
    private seoSchemaValidator: SeoSchemaValidator,

    private _injector: Injector,

    protected dialog: MatDialog,
    private detectDesktopService: DetectDeviceService,
  ) { 
    super(dialog, detectDesktopService);

    this.isServer = isPlatformServer(this.platformId);
  
  }

  @ViewChild('tournaments', { static: false, read: ViewContainerRef })
  public tournamentsRef: ViewContainerRef;

  @ViewChild('missions', { static: false, read: ViewContainerRef })
  public missionsRef: ViewContainerRef;

  @ViewChild('promotion', { static: false, read: ViewContainerRef })
  public promotionRef: ViewContainerRef;

  @ViewChild('reactivation', { static: false, read: ViewContainerRef })
  public reactivationRef: ViewContainerRef;

  // @ViewChild('xmas', { static: false, read: ViewContainerRef })
  // public xmasRef: ViewContainerRef;

  protected isShowTournamentsModulePlaceholder = true;
  protected isShowRectivationModulePlaceholder = true;
  protected isShowXmasModulePlaceholder = true;
  protected isShowMissionsModulePlaceholder = true;
  protected isShowPromotionsModulePlaceholder = true;

  isServer: boolean;

  bonusDisplayName = $localize`:@@HomeEssentialsComponent.playWithBonus:Play With Bonus`;

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {

      timer(300).pipe(take(1)).subscribe(() => {
        const scrollPos = this.prevUrlService.getScrollPosition() || 0;
        this.windowRef.scrollTo(0, scrollPos);
        if (scrollPos > 0) {
          setTimeout(() => this.prevUrlService.reset(), 100);
        }
        this.loginStatusService.getIfUserLogged().pipe(take(1), takeUntil(this.unsubscribe)).subscribe(resp => {
          combineLatest({
            // here pay list income
            paymentResp: this.paymentListService.fetchPayment(resp.fullInfo?.country || 'en').pipe(
              filter(resp => resp.length !== 0),
              take(1)),
            // here bonus list income
            // bonusResp: this.bonusListService.fetchData().pipe(
            //   filter(resp => resp.length !== 0),
            //   take(1))
          }
          ).subscribe((resp) => { })
        })
      })
    }
  }

  private _openLazyLoadedComponent<T>(
    importedFile: T,
    componentToOpen: Type<TournamentsCarouselComponent>
  ): void {
    this.isShowTournamentsModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.tournamentsRef.createComponent(componentToOpen, { ngModuleRef: moduleRef });
  }
  private _openLazyLoadedComponentMissions<T>(
    importedFile: T,
    componentToOpenMissions: Type<MissionsCarouselComponent>
  ): void {
    this.isShowMissionsModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.missionsRef.createComponent(componentToOpenMissions, { ngModuleRef: moduleRef });
  }
  private _openLazyLoadedComponentPromotion<T>(
    importedFile: T,
    componentToOpenMissions: Type<PromotionCarouselComponent>
  ): void {
    this.isShowPromotionsModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.promotionRef.createComponent(componentToOpenMissions, { ngModuleRef: moduleRef });
  }
  private _openLazyLoadedComponentReactivation<T>(
    importedFile: T,
    componentToOpenMissions: Type<ReactivationCarouselComponent>
  ): void {
    this.isShowRectivationModulePlaceholder = false;
    const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
    const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
    this.reactivationRef.createComponent(componentToOpenMissions, { ngModuleRef: moduleRef });
  }

  // private _openLazyLoadedComponentXmas<T>(
  //   importedFile: T,
  //   componentToOpenXmas: Type<XmasCarouselComponent>
  // ): void {
  //   this.isShowXmasModulePlaceholder = false;
  //   const module: Type<T> = (importedFile as any)[Object.keys(importedFile)[0]];
  //   const moduleRef: NgModuleRef<T> = createNgModule(module, this._injector);
  //   this.xmasRef.createComponent(componentToOpenXmas, { ngModuleRef: moduleRef });
  // }

  ngOnInit(): void {

    if (this.isServer) {
      firstValueFrom(this.desktopService.staticPromotionData('promotions-front')).then(res => {
        const promoPage = PromotionCarouselComponent.filterPromoPagebyCountry(res.data as CardWidgetPageResponse, this.locale);
        const cardWidgetElements = promoPage.cardWidgetElements as unknown as any[];
        this.transferState.set(PROMOTIONS_KEY, cardWidgetElements);
        // console.log('[FrontPage SSR (Mobile)] saved promotions to TransferState:', cardWidgetElements.length);
      }).catch(err => console.error('[FrontPage (SSR)] promotions fetch error', err));
    }

    if (!isPlatformServer(this.platformId)) {
      import('../../components/tournaments/tournaments-carousel.dynamic.module').then((importedFile) => {
        const componentToOpen =
          importedFile.TournamentsCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponent(importedFile, componentToOpen);
      });

      import('../../components/missions/missions-carousel.dynamic.module').then((importedFile) => {
        const componentToOpenMissions =
          importedFile.MissionsCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponentMissions(importedFile, componentToOpenMissions);
      });

      import('../../components/front-page/promotion-carousel/promotion-carousel.dynamic.module').then((importedFile) => {
        const componentToOpenPromotions =
          importedFile.PromotionCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponentPromotion(importedFile, componentToOpenPromotions);
      });
      import('../../components/reactivation/reactivation-carousel.dynamic.module').then((importedFile) => {
        const componentToOpenMissions =
          importedFile.ReactivationCarouselDynamicModule.components.dynamicComponent;
        this._openLazyLoadedComponentReactivation(importedFile, componentToOpenMissions);
      });

      // import('../../components/xmas/xmas-carousel.dynamic.module').then((importedFile) => {
      //   const componentToOpenXmas =
      //     importedFile.XmasCarouselDynamicModule.components.dynamicComponent;
      //   this._openLazyLoadedComponentXmas(importedFile, componentToOpenXmas);
      // });
    }
    
    // this.loadingService.show();
    this.toggleBackService.hideBack();
    // this.titleService.setTitle($localize`:@@title-front-page:Lemon Casino - best games online`);

    this.bonusService.getActiveBonus().pipe(takeUntil(this.unsubscribe), take(1)).subscribe((res) => {

      if (!this.activeBonusCategory) {
        this.activeBonusCategory = [];
      }

      const games = res.includedGamesList?.[0]?.games || [];

      if (games.length > 0) {
        const newCategory: GameCategory = {
          icon: {url: "assets/icons/categories/icon-bonus-buy.svg"},
          id: res.bonus_ref,
          name: activeBonusCategoryTrx,
          displayName: this.bonusDisplayName,
          game: games,
          displayType: 'square'
        };

        this.activeBonusCategory = [...this.activeBonusCategory, newCategory];
      }
    });

    this.frontPageGamesService.fetchData().pipe(
      takeUntil(this.unsubscribe)
    ).subscribe((response) => {
      let pageData = response.pagesCategories?.[0];
      
      if (!pageData) {
        this.loadingService.hide();
        return;
      }
  
      let categories = this.cloneService.deepClone<GameCategory[]>(pageData.categories);

      this.updateHeaderService.secondary_fallback = {
        title: pageData?.seo?.metaTitle ?? '',
        description: pageData?.seo?.metaDescription ?? ''
      };

      if (!this.route?.snapshot?.firstChild) {
        this.setSEOTags(pageData.seo?.metaTitle, pageData.seo?.metaDescription);
      }
      this.seoSchemaValidator.setHomePageMetaDescription(pageData.seo?.metaDescription);

      this.categories = categories;
      this.operators = (response.operators?.[0] as any)?.categories || [];
      this.loadingService.hide();
    });

    this.apollo
      .watchQuery<ExapnsionPanels>({
        query: FRONT_PAGE_EXPANSION_PANEL,
        variables: {
          locale: this.locale,
          licenseName: this.licence
        }
      })
      .valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((response) => {
        const expansionPanelResponse = response.data.expansionPanels.find((panel) => panel.licence?.includes(this.licence) || panel.licence?.includes('all')) || response.data.expansionPanels[0];
        const resp: ExpansionPanelItem[] = this.cloneService.deepClone(expansionPanelResponse.item);

        this.expansionPanel = resp.map(item => {
          if (!!item && !!item.content) {
            item.content.text = item.content.html.replace(/<[^>]+>/g, '');
            item.content.safehtml = this.sanitizer.bypassSecurityTrustHtml(item.content.html);
            return item;
          }
        });
      });

    this.loginStatusService.getIfUserLogged().pipe(take(1), takeUntil(this.unsubscribe)).subscribe((status) => {
      const roles = status.fullInfo?.roles?.map((item: string) => item.toLowerCase()) ?? [];
      const hasVip = !!roles.some((item: string) => ['vip', 'supervip', 'super_vip', 'potential_vip'].includes(item));

      let chatType: string | null = null;
      if (hasVip) {
        chatType = `vip-${this.locale}`;
        loadChatScript(chatType, status.username, status.fullInfo.first_name);
        this.chatAccess.setInitializedByChatType(chatType); 
        this.chatAccess.setVip(true);

      } else if (this.locale !== "pl") {
        chatType = this.locale;
        loadChatScript(chatType, status.username, status.fullInfo.first_name);
        this.chatAccess.setInitializedByChatType(chatType);
        this.chatAccess.setVip(false);

      } else {
        this.chatAccess.setDisabled(); 
        this.chatAccess.setVip(false);
      }

      // console.log("chat enabled 2");
    });

    this.setSchemaSet();
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const componentPosition = this.elementRef?.nativeElement?.querySelector('#expansionPanel')?.offsetTop;
    if (!componentPosition) return;
    const scrollPosition = window.pageYOffset + window.innerHeight;
    if (scrollPosition >= componentPosition) {
      if (this.expansionPanel) {
        this.expansionPanel.forEach(element => {
          element.display = true;
        });
      }
    }
  }

  onFilterSelect(item: SearchDataItem) {
    this.searchGamesService.saveSearchHistory('');

    for (let category of this.searchCategories) {
      const categoryItem = category.data.find((_item) => _item.name === item.name);

      if (categoryItem) {
        categoryItem.selected = true;
        break;
      }
    }

    this.searchGamesService.setSearchFilters(this.searchCategories)
    this.router.navigate(['/' + searchGameTrx])
  }

  onSwiperCategoryClick(link: string) {
    this.router.navigate([link]);
  }

  onGameClick(game: any) {
    if (game?.systemName) {
      this.prevUrlService.setScrollPosition(this.windowRef.scrollY);
      this.router.navigate(["", this.translationConfig.getTranslation(gameInfoTrx), game?.systemName]);
    }
    //console.log('onGameClick game =>', game)
  }

  setSchemaSet() {
    if (this.locale !== 'pl') return;

    const domainValue = getDomainForLanguage(this.locale);
    const domain = `https://${domainValue}/${this.locale}`;
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${domain}/#organization`,
          "name": "Lemon Casino",
          "legalName": "Orange Entertainment B.V.",
          "url": domain,
          "logo": {
            "@type": "ImageObject",
            "url": `${domain}/logo.png`
          },
          "foundingDate": "2021",
          "description": "Lemon Casino to międzynarodowe kasyno online działające od 2021 roku. Oferujemy ponad 9 500 gier od ponad 60 dostawców, kasyno na żywo z ponad 410 stołami oraz platformę mobilną PWA.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Korporaalweg 10",
            "addressLocality": "Curaçao",
            "addressCountry": "CW"
          },
          "identifier": [
            {
              "@type": "PropertyValue",
              "name": "Numer rejestracyjny",
              "value": "158249"
            },
            {
              "@type": "PropertyValue",
              "name": "Licencja",
              "value": "OGL/2024/1111/0488"
            }
          ],
          "sameAs": [
            "https://t.me/lemoncasino"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "availableLanguage": ["Polish", "English"]
          },
          "paymentAccepted": "BLIK, Visa, Mastercard, Apple Pay, Google Pay, MiFinity, Revolut, Paysafecard, Neosurf, CashtoCode, Bitcoin, Ethereum, Tether",
          "currenciesAccepted": "PLN, EUR, BTC, ETH, USDT"
        },
        {
          "@type": "WebSite",
          "@id": `${domain}/#website`,
          "url": domain,
          "name": "Lemon Casino",
          "description": "Oficjalna strona Lemon Casino – kasyno online z ponad 9 500 grami, bonusem powitalnym do 1 200 zł i kasinem na żywo.",
          "publisher": {
            "@id": `${domain}/#organization`
          },
          "inLanguage": "pl",
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": `${domain}/search-game`
            },
            "query-input": "required name=search_term_string"
          }
        },
        {
          "@type": "WebPage",
          "@id": `${domain}/#webpage`,
          "url": `${domain}`,
          "name": "Lemon Casino – Kasyno Online",
          "description": "Oficjalna strona Lemon Casino. Ponad 9 500 gier, bonus powitalny 100% do 1 200 zł + 100 darmowych spinów, kasyno na żywo, BLIK, kryptowaluty. Licencja CGA.",
          "isPartOf": {
            "@id": `${domain}/#website`
          },
          "about": {
            "@id": `${domain}/#organization`
          },
          "inLanguage": "pl",
          "breadcrumb": {
            "@id": `${domain}/#breadcrumb`
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": `${domain}/#breadcrumb`,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Lemon Casino",
              "item": `${domain}`
            }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": `${domain}/#faq`,
          "isPartOf": {
            "@id": `${domain}/#webpage`
          },
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Czy Lemon Casino jest legalne i licencjonowane?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Tak. Lemon Casino działa na podstawie licencji OGL/2024/1111/0488 wydanej przez Curaçao Gaming Authority dla Orange Entertainment B.V. Licencja jest aktywna i weryfikowalna."
              }
            },
            {
              "@type": "Question",
              "name": "Jak się zarejestrować w Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kliknij przycisk Rejestracja w prawym górnym rogu strony, podaj e-mail i hasło, potwierdź konto. Rejestracja zajmuje kilka minut – po jej zakończeniu masz dostęp do pełnej oferty platformy."
              }
            },
            {
              "@type": "Question",
              "name": "Jak zalogować się do Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kliknij Zaloguj się na stronie głównej i wprowadź dane konta. Logowanie działa zarówno przez przeglądarkę desktopową, jak i mobilną."
              }
            },
            {
              "@type": "Question",
              "name": "Ile gier oferuje Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Lemon Casino oferuje ponad 9 500 gier – sloty online, gry stołowe, gry crash, zręcznościowe oraz ponad 410 stołów kasyna na żywo od ponad 60 dostawców."
              }
            },
            {
              "@type": "Question",
              "name": "Jaki jest aktualny kod promocyjny Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Aktualny kod promocyjny Lemon Casino to LEMONCASINO – aktywuje 50 darmowych spinów bez depozytu na slot Sugar Rush od Pragmatic Play. Dostępny dla graczy z minimum jedną wcześniejszą wpłatą. Wpisz go w sekcji Profil → Kod promocyjny."
              }
            },
            {
              "@type": "Question",
              "name": "Czy Lemon Casino oferuje bonus bez depozytu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Tak. Kod promocyjny LEMONCASINO aktywuje 50 free spinów bez nowej wpłaty na Sugar Rush. Bonus powitalny (100% do 1 200 zł + 100 FS na Big Bass Splash) wymaga pierwszego depozytu od 40 zł."
              }
            },
            {
              "@type": "Question",
              "name": "Czy dostępna jest aplikacja Lemon Casino na telefon?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Tak. Aplikacja Lemon Casino działa jako PWA – bez pobierania z App Store ani Google Play. Wystarczy otworzyć stronę w przeglądarce mobilnej i dodać ją do ekranu głównego. Dla Androida dostępna jest też wersja APK."
              }
            },
            {
              "@type": "Question",
              "name": "Jakie metody płatności obsługuje Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Lemon Casino obsługuje BLIK, Visa, Mastercard, Apple Pay, Google Pay, MiFinity, Revolut, Paysafecard, Neosurf, CashtoCode oraz kryptowaluty Bitcoin, Ethereum i Tether (USDT)."
              }
            },
            {
              "@type": "Question",
              "name": "Jakie są limity wypłat w Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Dzienny limit wypłat wynosi do 2 500 €, miesięczny do 30 000 €. Przed pierwszą wypłatą może być wymagane ukończenie weryfikacji tożsamości (KYC)."
              }
            },
            {
              "@type": "Question",
              "name": "Czym jest Program VIP w Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Program VIP to trzypoziomowy system nagród (Bronze, Silver, Gold) dla najbardziej aktywnych graczy Lemon Casino. Status przyznawany jest na zaproszenie – aktywni gracze kwalifikują się automatycznie w miarę postępów."
              }
            },
            {
              "@type": "Question",
              "name": "Czy gry w Lemon Casino są uczciwe?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Tak. Wszystkie gry online działają w oparciu o certyfikowany generator liczb losowych (RNG). Sekcja live casino transmitowana jest w czasie rzeczywistym. RTP każdej gry widoczne jest w jej panelu informacyjnym."
              }
            },
            {
              "@type": "Question",
              "name": "Czy mogę ustawić limity gry w Lemon Casino?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Tak. Lemon Casino oferuje limity depozytów (dzienne, tygodniowe, miesięczne), czasowe ograniczenie dostępu do konta i opcję samowykluczenia. Narzędzia dostępne są w ustawieniach konta."
              }
            }
          ]
        }
      ]
    };

    try {
      this.seoSchemaValidator.addSchemaMarkup(schemaData);
    } catch (error) {
      console.error('Error setting schema markup:', error);
    }
  }

  ngOnDestroy() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    try {
      const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
      existingScripts.forEach(script => script.remove());
      // console.log('Schema markup cleared');
    } catch (error) {
      console.error('Error clearing schema markup:', error);
    }
  }



}
